import { useEffect } from 'react'
import { useUser } from '@ztechapps/common.hook'
import { useOpenReplay } from '../hooks/useOpenReplay'

/**
 * Identifies the current user for OpenReplay session recording.
 * Must be rendered inside OpenReplayProvider and only in authenticated contexts
 * (e.g., inside PrivateLayout) — useUser() fires a GraphQL query that requires auth.
 */
export const OpenReplayUserIdentifier = () => {
  const { user } = useUser()
  const { setUserID, setMetadata } = useOpenReplay()

  useEffect(() => {
    const email = user?.profile?.email
    const name = user?.profile?.name
    if (email) {
      setUserID(email)
    }
    if (name) {
      setMetadata('name', name)
    }
  }, [user?.profile?.email, user?.profile?.name, setUserID, setMetadata])

  return null
}
